import { Fragment } from "react";
import { Drawer, IconButton, useMediaQuery, useTheme } from "@mui/material";
import styles from "./LastFewPlots.module.css";
import { useDispatch, useSelector } from "react-redux";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { NewLaunchActions } from "redux-container/investments/new-launch/NewLaunchRedux";
import ProjectSearchDetails from "../../search/projects/ProjectDetailedCard";
import { useClickOutside } from "@mantine/hooks";
import { Overlay } from "@mantine/core";

const actionDispatch = (dispatch: any) => {
  return {
    setNewLaunchState: (key: any, value: any) =>
      dispatch(NewLaunchActions.setNewLaunchState(key, value)),
  };
};

const LastFewPlotsDrawer = () => {
  const { setNewLaunchState } = actionDispatch(useDispatch());

  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { isLastFewPlotsDialogOpen, collectionOnes, newLaunchData } =
    useSelector((state: any) => ({
      isLastFewPlotsDialogOpen: state?.newLaunch?.isLastFewPlotsDialogOpen,
      collectionOnes:
        state?.newLaunch?.newLaunchData?.pageManagementsOrCollectionOneModels,
      newLaunchData: state?.newLaunch?.newLaunchData,
    }));

  const toggleDrawer = () => {
    setNewLaunchState("isLastFewPlotsDialogOpen", false);
  };

  const ref = useClickOutside(toggleDrawer, ["mouseup", "mousedown"]);

  const handleClose = () => {
    setNewLaunchState("isLastFewPlotsDialogOpen", false);
  };

  return (
    <>
      {isLastFewPlotsDialogOpen && (
        <Overlay onClick={handleClose} opacity={0.2} color="#000" blur={5} />
      )}
      <Drawer
        anchor={"right"}
        open={isLastFewPlotsDialogOpen}
        onClose={handleClose}
        PaperProps={{
          ref: ref,
          style: isMediumScreen
            ? {
                width: "100%",
                marginTop: "0px",
                padding: "20px 20px 120px 20px",
              }
            : {
                width: "50%",
                // marginTop: "125px",
                padding: "20px 20px 120px 20px",
              },
        }}
      >
        <div className={styles["heading-holder"]}>
          <h2>{newLaunchData?.page?.collectionOne?.heading}</h2>
          <IconButton aria-label="close" onClick={toggleDrawer}>
            <CloseRoundedIcon />
          </IconButton>
        </div>

        <Fragment>
          {collectionOnes &&
            collectionOnes.length &&
            collectionOnes.map((project: any, index: any) => {
              return (
                <ProjectSearchDetails
                  key={index}
                  launchName={project?.launchName}
                  city={project?.address?.city}
                  state={project?.address?.state}
                  mediaUrl={
                    project?.projectCoverImages?.homePageMedia?.value?.url
                  }
                  appreciation={
                    project?.generalInfoEscalationGraph?.estimatedAppreciation
                  }
                  startingPrice={project?.priceStartingFrom}
                  startingArea={project?.areaStartingFrom}
                  description={project?.shortDescription}
                  id={project?.id}
                  isSoldout={project?.isSoldOut}
                />
              );
            })}
        </Fragment>
      </Drawer>
    </>
  );
};

export default LastFewPlotsDrawer;
